module.exports = __webpack_public_path__ + "static/media/worst-sustainable.c996e85e.png";